<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between v-if="finished">
      <v-flex xs12 md12>
        <h1>Update Successful</h1>
        <h1>프로필 등록이 완료되었습니다</h1>

        <v-btn :to="`/`">Okay</v-btn>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-space-between v-if="!finished && !ready">
      <h1>Loading...</h1>
    </v-layout>
    <v-layout wrap justify-space-between v-if="!finished && ready">
      <v-flex xs12 md12>
        <h1>Check-In Identification</h1>
        <v-form ref="form">
          <v-text-field
            v-model="full_name"
            :rules="[rules.reasonable_length]"
            label="영문 이름 / English Name"
          ></v-text-field>
          여권 등에 표시된 공식적인 영문 이름을 입력해주세요.
          <!-- 영문 이름은 공식 영상 및 공지 등에 사용 될 수 있습니다.
           and used in official video captions/titles/descriptions -->
          <br /><b style="background: yellow;"
            >Used to verify your ID at Check-In</b
          >
          <br />
          <br />
          <v-text-field
            v-model="native_name"
            :rules="[rules.reasonable_length]"
            label="이름(한글) / Name (Japanese/Chinese/etc)"
          ></v-text-field>
          본인의 국가에서 사용하는 문자로 이름을 입력해주세요.
          <br />Used in official correspondance. Can be the same as English
          Name.
          <br />
          <v-radio-group
            v-model="gender"
            :mandatory="true"
            :rules="[rules.required]"
          >
            <div slot="label">
              성별 Your <strong>gender</strong> (as stated in your passport)
            </div>
            <v-radio label="남 Male" value="M"></v-radio>
            <v-radio label="여 Female" value="F"></v-radio>
          </v-radio-group>
        </v-form>
      </v-flex>
      <v-btn color="primary" @click="confirm">Save</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
export default {
  props: ['auth'],
  data: () => ({
    ready: false,
    full_name: '',
    native_name: '',
    gender: '',
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (!!value && value.length >= 2 && value.length < 32) ||
        'At least 2 characters',
    },
    finished: false,
  }),
  beforeMount: async function() {
    await this.$store.dispatch('loadProfile');
    this.$data.full_name = this.myprofile.full_name;
    this.$data.native_name = this.myprofile.native_name;
    this.$data.gender = this.myprofile.gender;
    this.$data.ready = true;
  },
  computed: {
    ...mapState(['myprofile']),
  },
  methods: {
    confirm: async function({router}) {
      if (this.$refs.form.validate()) {
        var res = await this.$store.dispatch('updateProfile', {
          data: {
            full_name: this.$data.full_name,
            native_name: this.$data.native_name,
            gender: this.$data.gender,
          },
        });
        console.log('check result', res);
        this.finished = true;
      }
    },
  },
};
</script>
